import { render, staticRenderFns } from "./BnNavigationButtons.vue?vue&type=template&id=1aa6c242&"
import script from "./BnNavigationButtons.vue?vue&type=script&lang=js&"
export * from "./BnNavigationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports